'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_tags_SvgTag(name, void$1) {
  this.H6 = null;
  this.H6 = name;
}
export { $c_Lcom_raquo_laminar_tags_SvgTag as $c_Lcom_raquo_laminar_tags_SvgTag };
$p = $c_Lcom_raquo_laminar_tags_SvgTag.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_tags_SvgTag;
/** @constructor */
function $h_Lcom_raquo_laminar_tags_SvgTag() {
}
export { $h_Lcom_raquo_laminar_tags_SvgTag as $h_Lcom_raquo_laminar_tags_SvgTag };
$h_Lcom_raquo_laminar_tags_SvgTag.prototype = $p;
var $d_Lcom_raquo_laminar_tags_SvgTag = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_tags_SvgTag, "com.raquo.laminar.tags.SvgTag", ({
  iS: 1,
  c8: 1
}));
export { $d_Lcom_raquo_laminar_tags_SvgTag as $d_Lcom_raquo_laminar_tags_SvgTag };
